import React, { Component } from 'react'
import Turntable from '../../component/Turntable'

import { connect } from 'react-redux'
import withLocation from '../../component/HOC/withLocation'

import { Grommet } from 'grommet'
import cloneDeep from 'lodash.clonedeep'
import theme from '../../theme/theme'

import '../../styles/index.css'

import { setStartRotate } from '../../redux/turntable/actions'
import EmbWheel from '../../component/EmbComponent/EmbWheel'
import SEOEmb from '../../component/EmbComponent/SEOEmb'
import { getEmbedLink } from '../../redux/embed/actions'

const actions = {
  setStartRotate,
}

class EmbedWheel extends Component {
  state = {
    initialChoices: [],
    turntable: null,
    choices: [],
    turntableSize: 300,
    result: '',
    resultIndex: -1,
    mute: true,
    tooSmall: false,
    history: [],
    allResultsOpen: false,
    resetWord: 'Reset',
    title: '',
    confetti: false,
    mystery: false,
    color: '#222',
    weights: [],
    weightOn: false,
    showLogo: true,
    wheelColor: ['#2b580c', '#f7b71d', '#afa939', '#fdef96'],
  }

  checkFullyClaimed(fullChoices, filteredChoices) {
    return fullChoices.length !== 0 && filteredChoices.length === 0
  }

  setResult = (choice, index) => {
    const result = !choice ? '' : choice
    this.setState({
      result,
      resultIndex: index,
    })
  }

  componentDidMount() {
    const {
      choices,
      title,
      mute,
      confetti,
      color: colorInit,
      weightOn,
      showLogo,
      wheelColor,
    } = this.props.serverData
    const inputs = []
    const weights = []
    for (let i = 0; i < choices.length; i++) {
      inputs.push(choices[i].name)
    }
    if (weightOn) {
      for (let i = 0; i < choices.length; i++) {
        weights.push(choices[i].weight)
      }
    }
    this.setState({
      title,
      mute,
      confetti,
      weightOn,
      showLogo,
      wheelColor,
    })

    if (colorInit) {
      this.setState({
        color: colorInit.toLowerCase() === 'black' ? '#222' : '#e3e3e3',
      })
    }

    this.props.setStartRotate(2 * Math.PI * Math.random())

    const isBlankWheel = this.checkFullyClaimed(choices, inputs)

    const turntable = (
      <Turntable
        choices={inputs}
        weights={weights}
        weightOn={weightOn}
        size={this.state.turntableSize}
        completed={this.setResult}
        started={() => {
          this.setResult('')
        }}
        gaEvent={{ category: 'Embed Actions', action: 'Embed Spinning' }}
        mute={mute}
        isEmb={true}
        wheelColors={this.state.wheelColor}
        isBlankWheel={isBlankWheel}
      />
    )
    this.setState({
      turntable,
      choices,
      weights,
      initialChoices: cloneDeep(choices),
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.turntable === null) {
      const fChoices = this.state.choices.filter(
        choice => choice.filtered === false,
      )
      const inputs = []
      for (let i = 0; i < fChoices.length; i++) {
        inputs.push(fChoices[i].name)
      }

      const isBlankWheel = this.checkFullyClaimed(this.state.choices, inputs)

      const turntable = (
        <Turntable
          choices={inputs}
          weights={this.state.weights}
          weightOn={this.state.weightOn}
          size={this.state.turntableSize}
          completed={this.setResult}
          started={() => {
            this.setResult('')
          }}
          gaEvent={{ category: 'Embed Actions', action: 'Embed Spinning' }}
          mute={this.state.mute}
          isEmb={true}
          wheelColors={this.state.wheelColor}
          isBlankWheel={isBlankWheel}
        />
      )
      this.setState({ turntable: turntable })
    }
  }

  changeState = state => {
    this.setState(state)
  }

  render() {
    return (
      <Grommet theme={theme}>
        <EmbWheel {...this.state} changeState={this.changeState} />
      </Grommet>
    )
  }
}

export default connect(null, actions)(withLocation(EmbedWheel))

export const Head = () => (
  <SEOEmb title="Picker Wheel" canonical="https://pickerwheel.com/" />
)

export async function getServerData(context) {
  try {
    const sharePath = context.params.id
    const path = sharePath.replace(/\//g, '')
    const data = {
      path,
    }
    const json = await getEmbedLink(data)
    return {
      props: json.result.data,
    }
  } catch (error) {
    console.log(error)
    return {
      status: 500,
      headers: {},
      props: {},
    }
  }
}
